import { removeZipCodeFromAddress, getAddressWithApartmentString } from 'shared/lib/addressFields';
import type { TOrganizationData } from 'shared/types/TOrganizationFields';

import type { TWorkplaceFormFields, TCreditFormCommonFields, TCreditFormDictionaries } from 'entities/creditForm';

import { findAreaOfEmploymentByOkved } from './findAreaOfEmploymentByOkved';
import { findEmployerTypeByOpfCode } from './findEmployerTypeByOpfCode';
import { getProperOrganizationName } from './getProperOrganizationName';

export const convertDadataOrganizationToFormFields = (
  organization: TOrganizationData,
  currentData: Partial<TCreditFormCommonFields>,
  dictionaries: Partial<TCreditFormDictionaries>,
): Partial<TWorkplaceFormFields> => {
  const { value, data } = organization;
  const { opf, inn, address, okved, phones, name } = data || {};
  const { code: opfCode } = opf || {};
  const { short: shortOrgName } = name || {};
  const { value: suggestAddress, data: addressData } = address || {};
  let addressValue = suggestAddress;

  const { fullName, registrationAddress, registrationAddressFlat } = currentData;

  if (opfCode === '50102' && value.includes(String(fullName?.value || ''))) {
    /** Для ИП, кто работает сам на себя, подставляем адрес регистрации в рабочий адрес */
    addressValue =
      getAddressWithApartmentString(String(registrationAddress?.value) || '', registrationAddressFlat || '') ||
      addressValue;
  }

  addressValue = removeZipCodeFromAddress(addressValue);

  const dataToUpdate: Partial<TWorkplaceFormFields> = {
    workOrganizationName: getProperOrganizationName([value, shortOrgName]),
    areaOfEmployment:
      findAreaOfEmploymentByOkved(okved, dictionaries.areasOfEmployment || []) ||
      dictionaries.areasOfEmployment?.find(({ value }) => value === 'Other'),
    ...(okved ? { okved } : {}),
    employerType:
      findEmployerTypeByOpfCode(opfCode, dictionaries.employerTypes || []) ||
      dictionaries.employerTypes?.find(({ value }) => value === 'DontKnow'),
    employerInn: inn,
    workAddress: {
      value: addressValue,
      label: addressValue,
      data: addressData,
    },
  };

  if (phones?.length) {
    const phone = phones.reduce((correctNumber: string, currentPhone) => {
      if (correctNumber) {
        return correctNumber;
      }
      const currentValue = currentPhone.value || '';
      const trying = currentValue.split(',')[0].replace(/\D/g, '');
      if (trying.length >= 10) {
        return trying;
      }

      return correctNumber;
    }, '');

    dataToUpdate.workPhone = `+7${phone.slice(-10)}`;
  }

  return dataToUpdate;
};
